import { render, staticRenderFns } from "./ShenzhenUnicomJd02.vue?vue&type=template&id=2be8de92&scoped=true"
import script from "./ShenzhenUnicomJd02.vue?vue&type=script&lang=js"
export * from "./ShenzhenUnicomJd02.vue?vue&type=script&lang=js"
import style0 from "./ShenzhenUnicomJd02.vue?vue&type=style&index=0&id=2be8de92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be8de92",
  null
  
)

export default component.exports